import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { INavigationBarItem } from '@shared/models/models';
import { Subject, Subscription } from 'rxjs';
import { AppState } from 'src/app/core/store/app.reducers';
import { sidebarAnimation, iconAnimation, labelAnimation } from './animations';
import { Location } from '@angular/common';
import { GeneralService } from '@app-services/general/general.services';
import { AuthService } from '@app-core/services/auth/auth.service';
import { takeUntil } from 'rxjs/operators';
import { UIActions } from 'src/app/core/store/actions/ui/actions';
import { ZenDeskService } from '@app-services/zenDesk/zen-desk.service';
import { NgxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';
import { ZendeskConfig } from '@shared/class/zenDesk.class';
import _get from 'lodash/get';
@Component({
  selector: 'app-sidebar-nav',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [sidebarAnimation(), iconAnimation(), labelAnimation()],
})
export class SidebarComponent implements OnInit, OnDestroy {
  sidebarState: string;

  subscription: Subscription = new Subscription();
  sidebarToggle: boolean;

  public user;
  userInfo: any;
  isopen = true;
  private ngUnsubscribe$: Subject<any> = new Subject();

  @Input() items: INavigationBarItem[];
  @Input() logo: string;
  @Input() avatar: string;
  @Input() color: string;
  public mobileMainItems: INavigationBarItem[];
  public mobileRemainingItems: INavigationBarItem[];
  public desktopLastItem: INavigationBarItem;
  public defaultColor = '#4b2cdc';
  public access;
  public isCustomer;
  public isCandidate;
  public permissions = [];
  sidebarToggleMouse = false;
  inp: boolean;

  constructor(
    private readonly location: Location,
    private generalService: GeneralService,
    private authService: AuthService,
    private store: Store<AppState>,
    public _NgxZendeskWebwidgetService: NgxZendeskWebwidgetService,
    public zenDeskService: ZenDeskService
  ) {
    this.permissions = JSON.parse(localStorage.getItem('permissions'));
  }

  ngOnInit(): void {
    this.subscription = this.store.select('ui').subscribe((event) => {
      if (event.sidebarOpen == 'mouseout') {
        this.sidebarToggle = false;
        this.sidebarState = event.sidebarOpen;
      } else if (event.sidebarOpen == 'mouseopen') {
        this.sidebarToggle = true;
        this.sidebarState = event.sidebarOpen;
      } else if (event.sidebarOpen == 'open') {
        this.sidebarToggleMouse = false;
        this.sidebarToggle = true;
        this.sidebarState = event.sidebarOpen;
      } else {
        this.sidebarState = event.sidebarOpen;
        this.sidebarToggle = false;
        this.sidebarToggleMouse = true;
      }
    });

    this.user = JSON.parse(localStorage.getItem('userData'));

    this.generalService
      .getUserInformation(this.user.id)
      .pipe(takeUntil(this.ngUnsubscribe$));

    this.access = this.permissions.includes('Admin');
    this.loadZenDesk();
  }

  public goBack(): void {
    this.location.back();
  }

  public logout(): void {
    this.authService.logout();
  }

  async loadZenDesk() {
    this._NgxZendeskWebwidgetService.isInitialized();
    try {
      await this._NgxZendeskWebwidgetService.initZendesk(new ZendeskConfig());
      this._NgxZendeskWebwidgetService.zE('webWidget:on', 'close', () => {
        this._NgxZendeskWebwidgetService.zE('webWidget', 'hide');
      });
      this.zenDeskService.update(true);
    } catch (error) {
      this.zenDeskService.update(false);
    }
  }

  showZenDesk() {
    this._NgxZendeskWebwidgetService.zE('webWidget', 'show');
    const iframe: HTMLIFrameElement = document.querySelector(
      '#launcher'
    ) as HTMLIFrameElement;
    const embed: HTMLElement = iframe.contentDocument.querySelector('#Embed');
    embed.querySelector('button').id = 'btn-zendesk_employee';
    if (iframe) {
      const buttonZenDesk: HTMLElement = iframe.contentDocument.querySelector(
        '#Embed #btn-zendesk_employee'
      );
      if (buttonZenDesk) {
        buttonZenDesk.click();
        const user = JSON.parse(localStorage.getItem('userData'));
        const name = _get(user, 'name', '');
        const email = _get(user, 'email', '');
        this._NgxZendeskWebwidgetService.zE('webWidget', 'prefill', {
          name: {
            value: name,
            readOnly: true,
          },
          email: {
            value: email,
            readOnly: true,
          },
        });
      }
    }
  }

  selectApp(): void {
    this.authService.goToApp();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.ngUnsubscribe$.next(null);
    this.ngUnsubscribe$.complete();
  }
  toggleSideNav(type: string) {
    if (type == 'in') {
      if (this.sidebarState == 'open') {
        this.isopen = true;
      } else {
        this.isopen = false;
        this.store.dispatch({
          type: UIActions.UI_SIDEBAR_SET_STATE,
          payload: 'open',
        });
      }
    } else if (type == 'out') {
      if (!this.isopen) {
        this.store.dispatch({
          type: UIActions.UI_SIDEBAR_SET_STATE,
          payload: 'close',
        });
      }
    } else {
      if (this.sidebarToggleMouse) {
        if (type == 'mouseopen') {
          setTimeout(() => {
            if (this.inp) {
              if (this.sidebarState == 'mouseopen') {
                this.isopen = true;
              } else {
                this.isopen = false;
                this.store.dispatch({
                  type: UIActions.UI_SIDEBAR_SET_STATE,
                  payload: 'mouseopen',
                });
              }
            }
          }, 500);
        } else if (type == 'mouseout') {
          this.store.dispatch({
            type: UIActions.UI_SIDEBAR_SET_STATE,
            payload: 'mouseout',
          });
        }
      }
    }
  }
}
